export default __webpack_public_path__ + "static/media/instagram.edb90ecc.png";